import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics, logEvent } from 'firebase/analytics';
import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
} from '../common/constants/env.constants';

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;

if (typeof window !== 'undefined') {
  analytics = getAnalytics(firebaseApp);
}

// Custom event tracking functions
export const trackEvent = (
  eventName: string,
  parameters?: Record<string, string | undefined | number>,
) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};

export const trackPageView = (pageName: string, additionalData?: Record<string, string>) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_location: pageName,
    ...additionalData,
  });
};

export const trackUserAction = (
  action: string,
  category?: string,
  label?: string,
  value?: number,
) => {
  trackEvent('user_action', {
    action,
    category,
    label,
    value,
  });
};

export default firebaseApp;
